import { HTMLElement, addClass, hasAttribute, hasDataAttribute, hasId, query } from "@acng/frontend-bounty";
import { createPopupController } from "./controller.js";
import { globalPopupController, popup, popupContext } from "./context.js";
import { CTX_PROVIDE } from "@acng/frontend-relativity/minify";
const DATA_DISCOVER = "discover";
const ID_GLOBAL = "global-popup-container";
let CSS_CONTAINER; // TODO ATTRIBUT HIER DRAUS MACHEN. ES SOLLTEN KEINE KLASSEN AUTOMATISCH GESETZT WERDEN!
let SELECT_CONTAINER;
const ERR_TARGET = "Target is not an HTMLElement";
export const setPopupContainerClassList = (...classList) => {
    CSS_CONTAINER = classList;
    SELECT_CONTAINER = classList.map(className => `.${className}`).join(',');
};
setPopupContainerClassList("popup-container");
/**
 * Provide a container for popups.
 *
 * @example
 * <popup-element>...</popup-element>
 *
 * @example
 * <popup-element data-discover></popup-element>
 *
 * @example
 * <popup-element data-discover id="popup:global"></popup-element>
 *
 * @example
 * <popup-element>
 *   <section>
 *     <h1>Headline</h1>
 *     <aside class="popup-target"></aside>
 *     <p>Check this out!</p>
 *   </section>
 * </popup-element>
 */
export class PopupElement extends HTMLElement {
    connectedCallback() {
        connectPopupController(this);
    }
}
export const connectPopupController = (element) => {
    DEBUG: if (hasAttribute(element, 'debug'))
        console.debug("discovery/popup/element connect", element);
    const container = query(SELECT_CONTAINER, element);
    if (container && !(container instanceof HTMLElement)) {
        throw Error(ERR_TARGET);
    }
    if (!container) {
        addClass(element, ...CSS_CONTAINER);
    }
    getPopupController(element).setContainer(container ?? element);
};
const getPopupController = (element) => !hasDataAttribute(element, DATA_DISCOVER)
    ? providePopupController(element)
    : hasId(element, ID_GLOBAL)
        ? globalPopupController
        : popup(element);
const providePopupController = (element) => popupContext[CTX_PROVIDE](element, createPopupController());
